import React from 'react';
import { IDexTrade, Network } from '@kattana-io/common';
import { useTradesTableData } from './useTradesTableData';
import { toFixed4 } from '../../DexTrades/formatters';
import { formatWallet } from './formatters';
import Text from '../../../atoms/Text';
import ModalTable from '../ModalTable/BodyTable';

export interface ITradesTableProps {
  trades: IDexTrade[];
  base: string;
  quote: string;
  base_decimals: number;
  quote_decimals: number;
  flipped: boolean;
  chain: string;
}

export interface ITopTradersTrade {
  amount0: string;
  amount1: string;
  blocknumber: number;
  bot: number;
  buy: number;
  chain: string;
  date: string;
  format_date: string;
  order: number;
  pair: string;
  price_a: number;
  price_a_usd: number;
  price_b: number;
  price_b_usd: number;
  tx: string;
  value_usd: number;
  wallet: string;
}

const getClassNameForRow = (rowData: ITopTradersTrade | undefined): string => {
  if (rowData) {
    if (rowData.buy) {
      return 'row__buy';
    }
    return 'row__sell';
  }
  return '';
};

const TradesTable = (props: ITradesTableProps) => {
  const onTxClick = (tx: string) => {
    const txUrl = Network.fromChain(props.chain)?.getScan() || '';
    window.open(`${txUrl}${tx}`);
  };

  const { base, quote, trades, base_decimals, quote_decimals, flipped } = props;

  const { columns, data } = useTradesTableData({
    trades,
    base,
    quote,
    flipped,
  });

  const Cell = (cell: any, row: ITopTradersTrade): React.ReactNode => {
    switch (cell.column.id) {
    case 'priceAUsd':
      return (
        <Text size={12} className={getClassNameForRow(row)}>
          ${toFixed4(cell.value)}
        </Text>
      );
    case 'priceA':
      return <Text size={12}>({toFixed4(cell.value)})</Text>;
    case flipped ? 'amount1' : 'amount0':
      return (
        <Text size={12}>
          {toFixed4(Number(cell.value) / 10 ** base_decimals)}
        </Text>
      );
    case flipped ? 'amount0' : 'amount1':
      return (
        <Text size={12}>
          {toFixed4(Number(cell.value) / 10 ** quote_decimals)}
        </Text>
      );
    case 'valueUsd':
      return <Text size={12}>${toFixed4(Number(cell.value))}</Text>;
    case 'tx':
      return (
        <Text
          size={12}
          onClick={() => onTxClick(cell.value)}
          className='attach_right link__color'
        >
          {formatWallet(cell.value)}
        </Text>
      );
    default:
      return <Text size={12}>{cell.value}</Text>;
    }
  };

  return <ModalTable data={data} columns={columns} renderCell={Cell} />;
};

export default TradesTable;
